<div *ngIf="!hasValidInitError()" class="fileset-error-container">
    <div class="fileset-error">
        {{ 'lf_fileset_init_general_error' | localize: lfFilesetLocalizeHelper }}
    </div>
</div>
<div *ngIf="hasValidInitError() && errors && errors.length" class="fileset-error-container">
    <div *ngIf="hasTypeError()" class="fileset-error">
        {{ 'lf_fileset_file_type_general_error' | localize: lfFilesetLocalizeHelper }}
    </div>
    <div *ngIf="hasFileError()" class="fileset-error">
        {{ { key: 'lf_fileset_required_status_general_error', args: [requiredStatus.DisplayName] } | localize: lfFilesetLocalizeHelper }}
    </div>
</div>
